import { IHighChartsAttributesModel } from '../../models/high-charts-attributes.interface';
import { PieChartWorker } from './pie-chart.worker';


/**
 * PieChartWorker: chart worker specific to a Pie Chart.
 * @param {any} config JSON object representing the chart configuration.
 * @param {IHighChartsAttributesModel} highChartsAttributes an object containing properties used to augment the chart configuration.
 */
export class PortfolioEditorPieChartWorker extends PieChartWorker {
	constructor(config: any, highChartsAttributes: IHighChartsAttributesModel) {
		super(config, highChartsAttributes);
	}

	public transformData(): void {
		this.config.colors = [];
		this.config.series = this.highChartsAttributes.customAttributes;
		this.config.title.text = this.highChartsAttributes.customAttributes.isKpiDonut ? this.highChartsAttributes.title : '';

		if (this.highChartsAttributes.customAttributes.isOriginalDonut) {
			this.config.chart.height = '130px';
			this.config.chart.width = '130px';
		}
	}

	public updateData(data: Array<any>): void {
		this.chart?.series?.[0]?.setData(data);
	}
}
